module.exports = __webpack_public_path__ + "img/app_ewm.0064505c.png";